import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {catchError, map, Observable, switchMap} from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class ImageService {

    api = environment.apiUrl;

    constructor(private http: HttpClient) { }

  getImage(id: number, isThumb: boolean = true, uri?: string): Observable<string> {
    const url = `${this.api}${uri || 'BuildingFiles/DownloadFile?fileID='}${id}&isThumb=${isThumb}`;

    return this.http.get(url, { responseType: 'blob' }).pipe(
      map(blob => {
        const reader = new FileReader();
        return new Observable<string>(observer => {
          reader.onloadend = () => {
            observer.next(reader.result as string);
            observer.complete();
          };
          reader.readAsDataURL(blob);
        });
      }),
      switchMap(obs$ => obs$), // Разворачиваем вложенный Observable
      catchError(() => {
        return new Observable<string>(observer => {
          observer.complete();
        });
      })
    );
  }

}
